import { Box,Typography  } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { colors } from '../../Theme/tokens';

function DeviceTokenDesc() {
  return (
        <Accordion
      disableGutters
      elevation={0}
      sx={{
        mb: "14px",
        bgcolor: "transparent",
        border: `1px solid ${colors.border.default}`,
        borderRadius: "12px !important",
        "&:before": { display: "none" },
        "&.Mui-expanded": {mb:"20px !important"}
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: colors.nav.labelColor, fontSize: "18px" }} />}
        sx={{
          minHeight: "36px",
          "& .MuiAccordionSummary-content": { my: 0 },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <InfoOutlinedIcon sx={{ color: colors.nav.labelColor, fontSize: "16px" }} />
          <Typography
            sx={{
              fontSize: "15px",
              color: colors.text.primary,
              fontWeight:600
            }}
          >
            What is a device token?
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0 }}>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: "14px",
            letterSpacing: "0.5%",
            color: colors.text.gray,
            lineHeight: 1.6,
          }}
        >
          {/* A device token is created each time you log in from a new device or browser, and it lets us send push notifications to that specific device. Each device you've logged in from (e.g. work PC, laptop, phone) has its own separate token, even under the same account. If a token is removed, that device stops receiving notifications even if you're still logged in — you'll need to log in again on it to restore notifications. The most recently used token can't be removed, so at least one device always stays able to receive notifications. */}
          Each device/browser has its own notification token (e.g., your phone, laptop, and work PC each have separate tokens). Removing a token stops notifications on that device; log in again to restore it. The latest active token cannot be removed.
        </Typography>
      </AccordionDetails>
    </Accordion>
  )
}

export default DeviceTokenDesc